export function getFileExtension(fileName: string): string {
  const match = fileName.match(/\.([a-zA-Z0-9]+)$/);
  return match ? match[1].toUpperCase() : "";
}

export function getFileExtensionLower(fileName: string): string {
  return fileName.split(".").pop()?.toLowerCase() ?? "";
}
